var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 127,
    viewBox: "0 0 466 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_439_686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.504 92.9581V59.5278C373.504 52.0588 369.155 49.483 364.938 49.483C359.472 49.483 354.379 53.1597 354.379 61.1181V92.9581H331.774V32.4586H352.015L353.008 39.0713C358.225 33.0703 365.923 30.8683 372.381 30.9906C385.296 31.113 396.351 37.848 396.351 59.4054V92.9649H373.497L373.504 92.9581Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.509 92.9581V33.4373H303.655C303.586 33.4373 303.531 33.4916 303.531 33.5596V70.2997C303.531 82.8114 313.821 92.9581 326.509 92.9581Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.756 81.8123C263.834 76.79 267.811 69.321 267.935 61.7297C268.183 56.3403 266.57 50.3393 262.098 45.4392L270.044 36.1353L253.524 24.5002C251.539 27.0692 249.051 30.1343 246.942 32.8256C242.842 31.3576 238.5 30.5013 234.275 30.5013C215.274 30.5013 200.119 42.5033 200.119 61.485C200.119 80.4667 213.655 91.9794 234.275 91.9794C242.594 91.9794 245.33 95.6493 245.33 100.06C245.33 105.939 239.989 108.752 234.027 108.752C228.066 108.752 222.228 106.673 222.476 97.2396H200.988C199.747 115.732 212.042 127 234.02 127C251.532 127 268.797 119.653 268.797 100.06C268.797 96.7503 268.052 88.1804 256.75 81.8123H256.756ZM235.082 77.4424C225.971 77.4424 218.582 70.1569 218.582 61.1724C218.582 52.1878 225.971 44.9023 235.082 44.9023C244.193 44.9023 251.581 52.1878 251.581 61.1724C251.581 70.1569 244.193 77.4424 235.082 77.4424Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.864 31.1128C142.103 31.1128 124.839 40.4167 124.839 62.8305C124.839 85.2443 142.228 94.4259 159.864 94.4259C177.5 94.4259 194.888 84.8773 194.888 62.8305C194.888 40.7837 177.996 31.1128 159.864 31.1128ZM159.864 79.4675C150.753 79.4675 143.365 72.182 143.365 63.1975C143.365 54.213 150.753 46.9275 159.864 46.9275C168.975 46.9275 176.363 54.213 176.363 63.1975C176.363 72.182 168.975 79.4675 159.864 79.4675Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.411 32.4585L96.7756 39.0711C100.008 33.4371 105.714 30.9905 111.676 30.9905C117.637 30.9905 123.847 33.3148 127.823 37.4808L118.63 53.7712C114.901 50.8353 112.172 50.0945 108.319 50.0945C102.606 50.0945 97.7611 53.5266 97.7611 61.4849V92.9579H74.9077V32.4585H95.3972H95.411Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6062 31.3508C34.7763 30.9838 26.5819 33.0634 21.3648 38.9421L20.3723 32.4518H0V118.179H22.8534V87.8066C26.2097 91.8503 32.0471 94.2969 39.8694 94.2969C57.7538 94.2969 69.6767 81.1939 69.6767 62.7015C69.6767 44.2091 59.6146 32.4518 41.6062 31.3508ZM39.0631 79.0327C32.7432 79.0327 27.2573 75.5191 24.4868 70.3744C23.0808 68.0093 22.3572 65.1142 22.3572 62.0899C22.3572 59.0656 23.4185 56.0345 25.3552 53.717C28.3187 49.3606 33.3497 46.4994 39.0631 46.4994C48.1741 46.4994 55.5622 53.7849 55.5622 62.7695C55.5622 71.754 48.1741 79.0395 39.0631 79.0395V79.0327Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.302 92.958H298.28V19.7972C298.28 9.16124 287.99 0.543701 275.302 0.543701V92.958Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M303.731 26.376L303.511 3.89429C303.587 3.89429 303.655 3.89429 303.731 3.89429C316.24 3.89429 326.53 14.041 326.53 26.376H303.731Z",
    fill: "url(#paint0_linear_439_686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.087 43.3188C439.519 43.2916 444.112 38.6204 443.864 29.3051C443.857 28.9789 443.829 28.6458 443.864 28.3196C444.063 25.8322 443.002 24.7652 440.383 24.8604C436.234 25.0099 432.072 24.7924 427.923 24.9691C424.346 25.1254 422.788 23.8885 422.981 20.1574C423.064 18.4992 423.078 16.8341 423.071 15.1758C423.098 14.9856 423.133 14.7885 423.133 14.5846V4.7845C423.14 4.52625 423.14 4.28159 423.133 4.05052V0H417.681C408.846 0 401.678 7.06802 401.678 15.7807V18.4108H401.706C401.706 18.5943 401.678 18.771 401.678 18.9613C401.548 34.5313 401.444 50.1014 401.727 65.6646C401.892 74.6627 405.104 82.6958 412.223 88.7036C413.746 89.9881 416.11 91.2997 417.888 91.0755C422.444 90.5046 427.103 89.5871 431.307 87.8405C435.6 86.0599 438.66 82.6278 439.322 77.1569C437.075 77.1569 435.462 77.1909 433.857 77.1569C427.489 76.9938 423.457 73.7928 423.195 67.8326C422.85 59.9898 423.112 52.1266 423.112 43.3324C425.862 43.3324 427.971 43.3324 430.087 43.3324V43.3188Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M465.808 66.7248C465.428 66.65 465.318 69.117 463.65 71.2986C461.693 73.8744 457.834 75.7025 454.346 75.3219C447.834 74.6083 443.044 66.0792 442.63 66.4326C442.596 66.4665 442.61 66.5481 442.63 66.6093C442.658 67.6695 442.685 68.7365 442.706 69.7967V75.2132C442.217 84.3608 436.552 90.6405 427.186 92.2716C425.132 92.6318 423.057 92.9308 420.211 93.3794C438.75 101.868 459.536 92.0541 464.732 74.9482C464.822 74.6559 464.905 74.3637 464.98 74.0714C465.125 73.521 465.256 72.9637 465.373 72.3996C465.373 72.3928 465.373 72.386 465.38 72.3724C465.635 71.3802 466.324 66.8335 465.808 66.7248Z",
    fill: "url(#paint1_linear_439_686)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M455.036 71.9851C459.778 71.9851 463.623 68.1939 463.623 63.5171C463.623 58.8403 459.778 55.0491 455.036 55.0491C450.293 55.0491 446.448 58.8403 446.448 63.5171C446.448 68.1939 450.293 71.9851 455.036 71.9851Z",
    fill: "url(#paint2_linear_439_686)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_686",
    x1: 303.745,
    y1: 13.0827,
    x2: 323.009,
    y2: 25.5191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F79A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F16D55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_439_686",
    x1: 424.284,
    y1: 90.8716,
    x2: 464.589,
    y2: 69.4418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F79A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F27B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F16D55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_439_686",
    x1: 446.683,
    y1: 63.5171,
    x2: 463.857,
    y2: 63.5171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F79A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F6935E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F38059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F16D55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 466,
    height: 127,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayLogo);
export default __webpack_public_path__ + "static/media/overlay_logo.217938079dbaa47bc8064a932688224e.svg";
export { ForwardRef as ReactComponent };